import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { ApkService } from '../apk/apk.service';
import { PolicyCreatorState } from './store/policy-creator.state';

@Injectable({
  providedIn: 'root',
})
export class PolicyCreatorInitDataService {
  private inFlightLoad: Promise<void> | null = null;

  constructor(
    private readonly store: Store,
    private readonly apkService: ApkService,
  ) {}

  ensureCalculationDataLoaded(): Promise<void> {
    if (this.hasSodanReplyHeads() && this.hasBaseDataForCalculations()) {
      return Promise.resolve();
    }

    if (!this.inFlightLoad) {
      this.inFlightLoad = this.loadCalculationData().finally(() => {
        this.inFlightLoad = null;
      });
    }

    return this.inFlightLoad;
  }

  private async loadCalculationData(): Promise<void> {
    if (!this.hasSodanReplyHeads()) {
      await this.apkService.setSodanReplyHeads();
    }

    if (!this.hasBaseDataForCalculations()) {
      await this.apkService.setBaseDataForCalculations();
    }
  }

  private hasSodanReplyHeads(): boolean {
    const state = this.store.selectSnapshot(PolicyCreatorState.state);
    return !!state?.sodanReplyHeads;
  }

  private hasBaseDataForCalculations(): boolean {
    const state = this.store.selectSnapshot(PolicyCreatorState.state);

    if (state?.baseDataForCalculationsLoaded) {
      return true;
    }

    return !!(
      state?.portfolios?.length &&
      state?.vehicleCategories?.length &&
      state?.vehicleUsages?.length
    );
  }
}
